import React, { useEffect } from 'react';
import { setOnBlockedWrite, setReadOnlyMode } from 'client/Axios';
import { LocaleKey } from 'enums/locale-key.enum';
import { useToastContext } from 'context/ToastContext';
import SVGIcon from 'components/shared/SVGIcon';
// Sticky read-only-maintenance ticker (config.underMaintenance). Reads keep working; writes are paused.
// While it is mounted it also arms the client-side write-block (client/Axios) and shows a friendly toast
// if a write is attempted -- so the whole app degrades to read-only cleanly instead of raw 503s.
const MaintenanceTicker = () => {
    const { addToast } = useToastContext();
    useEffect(() => {
        setReadOnlyMode(true);
        setOnBlockedWrite(() => addToast({
            type: 'warning',
            title: LocaleKey.well_be_back_soon.h5locale().capitalize(),
            msg: LocaleKey.happy5_is_currently_under_maintenance_we_apologize_for_the_inconvenience_and_appreciate_your_patience
                .h5locale()
                .capitalizeSentences()
        }));
        return () => {
            setReadOnlyMode(false);
            setOnBlockedWrite(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement("div", { role: "status", className: "sticky top-0 z-[9999] flex w-full items-center justify-center gap-[8px] bg-y-100 px-[16px] py-[10px] text-n-900 shadow-sm" },
        React.createElement(SVGIcon, { iconName: "icon-under-construction", width: 16 }),
        React.createElement("p", { className: "typography-h100 text-center font-medium" }, LocaleKey.happy5_is_currently_under_maintenance_we_apologize_for_the_inconvenience_and_appreciate_your_patience
            .h5locale()
            .capitalizeSentences())));
};
export default MaintenanceTicker;
